import AuthApi from '@web/api/modules/Auth'
import UserApi from '@web/api/modules/User'
// import LocalStorage from '@web/common/LocalStorage'
import {
  AuthV3State,
  AuthV3GettersTree,
  AuthV3MutationsTree,
  AuthV3ActionsTree,
  AuthV3AuthOptions
} from '../types/modules/authV3'
import { useNewLk } from '@web/platform.v3/composables/useNewLk'
import Analytics from '@web/services/Analytics/Analytics'
import OneSignal from '@web/common/OneSignal'

// const AUTH_V3_EMAIL_KEY = 'ac_auth_email'
// const AUTH_V3_EMAIL_MASKED_DESTINATION_KEY = 'ac_auth_email_masked_destination'
// const AUTH_V3_EMAIL_STATUS_KEY = 'ac_auth_email_status'
// const AUTH_V3_PHONE_KEY = 'ac_auth_phone'
// const AUTH_V3_PHONE_MASKED_DESTINATION_KEY = 'ac_auth_phone_masked_destination'
// const AUTH_V3_PHONE_STATUS_KEY = 'ac_auth_phone_status'
// const AUTH_V3_TIMER_SECONDS_KEY = 'ac_auth_timer_seconds'
// const AUTH_V3_IS_TIMER_ACTIVE_KEY = 'ac_auth_is_timer_active'
// const AUTH_V3_IS_SEND_CODE_BY_SMS_KEY = 'ac_auth_is_send_code_by_sms'

const state: AuthV3State = {
  email: '', // LocalStorage.get(AUTH_V3_EMAIL_KEY) || '',
  maskedDestinationEmail: '', // LocalStorage.get(AUTH_V3_EMAIL_MASKED_DESTINATION_KEY) || '',
  emailStatus: 'email', // LocalStorage.get(AUTH_V3_EMAIL_STATUS_KEY) || 'email',
  phone: '', // LocalStorage.get(AUTH_V3_PHONE_KEY) || '',
  maskedDestinationPhone: '', // LocalStorage.get(AUTH_V3_PHONE_MASKED_DESTINATION_KEY) || '',
  phoneStatus: 'phone', // LocalStorage.get(AUTH_V3_PHONE_STATUS_KEY) || 'phone',
  needStartTimer: false, // LocalStorage.get(AUTH_V3_IS_TIMER_ACTIVE_KEY) === 'true' || false,
  timerSeconds: 0, // Number(LocalStorage.get(AUTH_V3_TIMER_SECONDS_KEY)) || 0,
  isTimerActive: false, // LocalStorage.get(AUTH_V3_IS_TIMER_ACTIVE_KEY) === 'true' || false,
  authOptions: {
    smsAvailable: false,
    vkIdAvailable: false,
    geoCountry: ''
  },
  isSendCodeBySMS: false, // LocalStorage.get(AUTH_V3_IS_SEND_CODE_BY_SMS_KEY) === 'true' || false
  isFetchedData: false
}

const getters: AuthV3GettersTree = {
  email: ({ email }) => email,
  maskedDestinationEmail: ({ maskedDestinationEmail }) => maskedDestinationEmail,
  emailStatus: ({ emailStatus }) => emailStatus,
  phone: ({ phone }) => phone,
  maskedDestinationPhone: ({ maskedDestinationPhone }) => maskedDestinationPhone,
  phoneStatus: ({ phoneStatus }) => phoneStatus,
  needStartTimer: ({ needStartTimer }) => needStartTimer,
  timerSeconds: ({ timerSeconds }) => timerSeconds,
  isTimerActive: ({ isTimerActive }) => isTimerActive,
  getAuthOptions: ({ authOptions }) => authOptions,
  isSendCodeBySMS: ({ isSendCodeBySMS }) => isSendCodeBySMS,
  isFetchedData: ({ isFetchedData }) => isFetchedData
}

const mutations: AuthV3MutationsTree = {
  setEmail (state, email) {
    state.email = email
    // LocalStorage.set(AUTH_V3_EMAIL_KEY, email)
  },
  setMaskedDestinationEmail (state, maskedDestinationEmail) {
    state.maskedDestinationEmail = maskedDestinationEmail
    // LocalStorage.set(AUTH_V3_EMAIL_MASKED_DESTINATION_KEY, maskedDestinationEmail)
  },
  setEmailStatus (state, emailStatus) {
    state.emailStatus = emailStatus
    // LocalStorage.set(AUTH_V3_EMAIL_STATUS_KEY, emailStatus)
  },
  setPhone (state, phone) {
    state.phone = phone
    // LocalStorage.set(AUTH_V3_PHONE_KEY, phone)
  },
  setMaskedDestinationPhone (state, maskedDestinationPhone) {
    state.maskedDestinationPhone = maskedDestinationPhone
    // LocalStorage.set(AUTH_V3_PHONE_MASKED_DESTINATION_KEY, maskedDestinationPhone)
  },

  setPhoneStatus (state, phoneStatus) {
    state.phoneStatus = phoneStatus
    // LocalStorage.set(AUTH_V3_PHONE_STATUS_KEY, phoneStatus)
  },
  setNeedStartTimer (state, needStartTimer) {
    state.needStartTimer = needStartTimer
  },
  setTimerSeconds (state, timerSeconds) {
    state.timerSeconds = timerSeconds
    // LocalStorage.set(AUTH_V3_TIMER_SECONDS_KEY, String(timerSeconds))
  },
  setIsTimerActive (state, isTimerActive) {
    state.isTimerActive = isTimerActive
    // LocalStorage.set(AUTH_V3_IS_TIMER_ACTIVE_KEY, isTimerActive.toString())
  },
  setField (state, { key, value }) {
    state[key] = value
  },
  setAuthOptions (state, authOptions) {
    state.authOptions = authOptions
  },
  setIsSendCodeBySMS (state, isSendCodeBySMS) {
    state.isSendCodeBySMS = isSendCodeBySMS
    // LocalStorage.set(AUTH_V3_IS_SEND_CODE_BY_SMS_KEY, isSendCodeBySMS.toString())
  },
  setIsFetchedData (state, isFetchedData) {
    state.isFetchedData = isFetchedData
  },
  reset (state) {
    state.email = ''
    state.maskedDestinationEmail = ''
    state.emailStatus = 'email'
    state.phone = ''
    state.maskedDestinationPhone = ''
    state.phoneStatus = 'phone'
    state.needStartTimer = false
    state.timerSeconds = 0
    state.isTimerActive = false
    state.isSendCodeBySMS = false
    // LocalStorage.remove(AUTH_V3_EMAIL_KEY)
    // LocalStorage.remove(AUTH_V3_PHONE_KEY)
    // LocalStorage.remove(AUTH_V3_EMAIL_MASKED_DESTINATION_KEY)
    // LocalStorage.remove(AUTH_V3_PHONE_MASKED_DESTINATION_KEY)
    // LocalStorage.remove(AUTH_V3_EMAIL_STATUS_KEY)
    // LocalStorage.remove(AUTH_V3_PHONE_STATUS_KEY)
    // LocalStorage.remove(AUTH_V3_TIMER_SECONDS_KEY)
    // LocalStorage.remove(AUTH_V3_IS_TIMER_ACTIVE_KEY)
    // LocalStorage.remove(AUTH_V3_IS_SEND_CODE_BY_SMS_KEY)
  }
}

let timerInterval: number | null = null

/* istanbul ignore next */
const actions: AuthV3ActionsTree = {
  getAuthOptions ({ commit }) {
    return AuthApi.getAuthOptions().then(({ data }) => {
      const authOptions = data ? data as AuthV3AuthOptions : undefined
      commit('setAuthOptions', authOptions)
      commit('setIsFetchedData', true)
    })
  },
  getCachedAuthOptions ({ state, dispatch }) {
    if (state.isFetchedData) {
      return Promise.resolve()
    }
    return dispatch('getAuthOptions')
  },
  requestEmailCode ({ commit }, email) {
    // LocalStorage.set('authV3_email', email)
    return AuthApi.login({
      email,
      method: 'email'
    }).then(({ data }) => {
      if (data.user) {
        const userSegments = data.user.segments
        const isShowNewLk = useNewLk().checkShowNewLk(userSegments)
        Analytics.setUserParams({ userId: data.user.id, typelk: isShowNewLk ? 'influence_lk' : 'standart_lk' })
        Analytics.setUserSegments(userSegments)
        OneSignal.setExternalUserId(data.user.id)

        commit('user/setShowNewLk', isShowNewLk, { root: true })
        commit('user/setUser', data.user, { root: true })
      }
      commit('setNeedStartTimer', true)
      commit('setMaskedDestinationEmail', data.maskedDestination)
    })
  },
  verifyEmailCode ({ commit }, { email, code }) {
    return AuthApi.verifyOtpLogin({ email, code })
      .then(({ data: user }) => {
        if (user) {
          const userSegments = user.segments
          const isShowNewLk = useNewLk().checkShowNewLk(userSegments)
          Analytics.setUserParams({ userId: user.id, typelk: isShowNewLk ? 'influence_lk' : 'standart_lk' })
          Analytics.setUserSegments(userSegments)
          OneSignal.setExternalUserId(user.id)

          commit('user/setShowNewLk', isShowNewLk, { root: true })
          commit('user/setUser', user, { root: true })
        }
      })
  },
  requestPhoneCode ({ commit }, { phone, useSms }) {
    return AuthApi.login({ phone, useSms, method: 'phone' })
      .then(({ data }) => {
        if (data?.user) {
          const userSegments = data.user.segments
          const isShowNewLk = useNewLk().checkShowNewLk(userSegments)
          Analytics.setUserParams({ userId: data.user.id, typelk: isShowNewLk ? 'influence_lk' : 'standart_lk' })
          Analytics.setUserSegments(userSegments)
          OneSignal.setExternalUserId(data.user.id)

          commit('user/setShowNewLk', isShowNewLk, { root: true })
          commit('user/setUser', data.user, { root: true })
        }
        commit('setNeedStartTimer', true)
        commit('setMaskedDestinationPhone', data.maskedDestination)
      })
  },
  verifyPhoneCode ({ commit }, { phone, code, useSms }) {
    return AuthApi.verifyOtpLogin({ phone, code, useSms })
      .then(({ data: user }) => {
        const userSegments = user.segments
        const isShowNewLk = useNewLk().checkShowNewLk(userSegments)
        Analytics.setUserParams({ userId: user.id, typelk: isShowNewLk ? 'influence_lk' : 'standart_lk' })
        Analytics.setUserSegments(userSegments)
        OneSignal.setExternalUserId(user.id)

        commit('user/setShowNewLk', isShowNewLk, { root: true })
        commit('user/setUser', user, { root: true })
      })
  },
  requestPhoneCodeForVerify (_, phone) {
    return UserApi.requestPhoneCode(phone)
  },
  verifyPhone ({ commit }, { phone, code }) {
    return UserApi.verifyPhoneCode({ phone, code })
      .then(() => {
        commit('user/setField', { key: 'requirePhoneValidate', value: false }, { root: true })
        commit('user/setField', { key: 'phoneValidated', value: true }, { root: true })
        commit('user/setField', { key: 'phone', value: phone }, { root: true })
      })
  },
  startTimer ({ commit }, seconds) {
    // Останавливаем предыдущий таймер, если он был запущен
    if (timerInterval) {
      clearInterval(timerInterval)
    }

    commit('setTimerSeconds', seconds)
    commit('setIsTimerActive', true)

    timerInterval = setInterval(() => {
      commit('setTimerSeconds', Math.max(0, seconds - 1))
      seconds--

      if (seconds <= 0) {
        commit('setIsTimerActive', false)
        if (timerInterval) {
          clearInterval(timerInterval)
          timerInterval = null
        }
      }
    }, 1000)
  },
  stopTimer ({ commit }) {
    if (timerInterval) {
      clearInterval(timerInterval)
      timerInterval = null
    }
    commit('setIsTimerActive', false)
  },
  resetTimer ({ commit }) {
    if (timerInterval) {
      clearInterval(timerInterval)
      timerInterval = null
    }
    commit('setTimerSeconds', 0)
    commit('setIsTimerActive', false)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
// eslint-disable-next-line @typescript-eslint/no-explicit-any
} as any
